import React from 'react';
import Immutable from 'immutable';

import { Block, Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity, ParagraphEntity, ReferenceField } from '@uncinc/react-drupal-core/types';

import DomainChooser from '../../../components/DomainChooser';
import HeroBuurtboerderij from '../../../components/Heros/HeroBuurtboerderij';
import HeroRegenboog from '../../../components/Heros/HeroRegenboog';
import { APP_OPTIONS, BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID } from '../../../config/constants';
import type { NodeLandingPage as Type } from '../../../types/uncinc_profile/nodes';
import HeroCtaMenu from '../../Menu/HeroCtaMenu';

import './style.scss';

interface NodeLandingPageProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<Type>;
}

const NodeLandingPage: React.FC<NodeLandingPageProps> = ({ entity }) => {
  const node = entity.toJS();
  const isFront = node.is_front;
  const title = node.field_title[0]?.value || node.title[0].value;
  const image = node.field_media_item[0]?.styles.crop_3_1;
  // @TODO: Fix this typing in RDC.
  const paragraphs = node.field_paragraphs as ReferenceField<ParagraphEntity>[];

  return (
    <article itemType="http://schema.org/WebPage" className="NodeLandingPageFull">
      <DomainChooser
        domains={{
          regenboog: <HeroRegenboog entity={entity} />,
          buurtboerderij: (
            <HeroBuurtboerderij small title={title} image={image}>
              {isFront && (
                <HeroCtaMenu />
              )}
            </HeroBuurtboerderij>
          ),
        }}
      />

      {paragraphs.length > 0 && (
        <div className="node--page--paragraphs-wrapper">
          {paragraphs.map((paragraph) => {
            const id = paragraph.target_id;
            const language = paragraph.entity?.langcode[0]?.value;

            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={Immutable.fromJS(paragraph.entity)}
              />
            );
          })}
        </div>
      )}

      <DomainChooser
        domains={{
          regenboog: <Block id={BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID} />,
          buurtboerderij: isFront ? (
            <Block id={APP_OPTIONS.parameters.blockIdBuurtboerderijAboutUs} />
          ) : null,
        }}
      />
    </article>
  );
};

export default NodeLandingPage;
